(() => {
  const desktopHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const productImageCache = new Map();

  const restoreAttribute = (element, name, value) => {
    if (value === null) {
      element.removeAttribute(name);
    } else {
      element.setAttribute(name, value);
    }
  };

  const productImages = async (productLink) => {
    const url = new URL(productLink.href, window.location.origin);
    url.search = '';
    url.hash = '';
    url.pathname = `${url.pathname.replace(/\/$/, '')}.js`;

    if (!productImageCache.has(url.href)) {
      productImageCache.set(
        url.href,
        fetch(url.href, { credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) throw new Error(`Product request failed: ${response.status}`);
            return response.json();
          })
          .then((product) =>
            (product.images || [])
              .map((image) => (typeof image === 'string' ? image : image.src))
              .filter(Boolean)
          )
          .catch(() => [])
      );
    }

    return productImageCache.get(url.href);
  };

  const preload = (url) =>
    new Promise((resolve) => {
      const image = new Image();
      image.onload = () => resolve(url);
      image.onerror = () => resolve(null);
      image.src = url;
    });

  const prepareCard = (card) => {
    if (card.dataset.taiaHoverGalleryReady === 'true') return;

    const productLink = card.querySelector('a[href*="/products/"]');
    const media = card.querySelector('.card__media .media');
    const featuredImage = media?.querySelector('img');

    if (!productLink || !media || !featuredImage) return;
    card.dataset.taiaHoverGalleryReady = 'true';

    let intervalId = null;
    let active = false;
    let previewImage = null;
    let previewWasAdded = false;
    let original = null;

    const stop = () => {
      active = false;
      window.clearInterval(intervalId);
      intervalId = null;

      if (!previewImage || !original) return;

      if (previewWasAdded) {
        previewImage.remove();
      } else {
        restoreAttribute(previewImage, 'src', original.src);
        restoreAttribute(previewImage, 'srcset', original.srcset);
        restoreAttribute(previewImage, 'sizes', original.sizes);
        restoreAttribute(previewImage, 'alt', original.alt);
      }

      previewImage = null;
      previewWasAdded = false;
      original = null;
    };

    const start = async () => {
      if (!desktopHover.matches || reducedMotion.matches) return;
      active = true;

      const existingImages = media.querySelectorAll('img');
      previewImage = existingImages[1] || featuredImage.cloneNode(true);
      previewWasAdded = existingImages.length < 2;

      if (previewWasAdded) media.appendChild(previewImage);

      original = {
        src: previewImage.getAttribute('src'),
        srcset: previewImage.getAttribute('srcset'),
        sizes: previewImage.getAttribute('sizes'),
        alt: previewImage.getAttribute('alt'),
      };

      const urls = await productImages(productLink);
      if (!active || urls.length < 2) return;

      const loadedUrls = (await Promise.all(urls.slice(0, 10).map(preload))).filter(Boolean);
      if (!active || loadedUrls.length < 2) return;

      let imageIndex = 1;
      const showNextImage = () => {
        if (!active) return;
        previewImage.removeAttribute('srcset');
        previewImage.removeAttribute('sizes');
        previewImage.src = loadedUrls[imageIndex];
        previewImage.alt = featuredImage.alt || '';
        imageIndex = (imageIndex + 1) % loadedUrls.length;
      };

      showNextImage();
      intervalId = window.setInterval(showNextImage, 1200);
    };

    card.addEventListener('pointerenter', start);
    card.addEventListener('pointerleave', stop);
    card.addEventListener('focusout', (event) => {
      if (!card.contains(event.relatedTarget)) stop();
    });
  };

  const initialize = () => {
    if (!desktopHover.matches || reducedMotion.matches) return;

    const productSections = Array.from(document.querySelectorAll('.shopify-section'))
      .filter((section) => section.querySelector('.card-wrapper.product-card-wrapper'))
      .slice(0, 2);

    productSections.forEach((section) => {
      section.querySelectorAll('.card-wrapper.product-card-wrapper').forEach(prepareCard);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
